import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '../vue_widgets/new_work_flow.vue'

export default class extends Controller {

  static values = {
    chatbotId: String,

  }

  connect(context) {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return
    console.log('location mgmt widget controller connected.')

    const props = {
      chatbotId: this.chatbotIdValue,

    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
